export namespace PIX {
  export interface IPixAddressKey {
    id: number;
    entityId: number;
    personType: number;
    pixAddressKeyType: string;
    pixAddressKey: string;
  }

  export class PixAddressKey implements IPixAddressKey {
    id: number = -1;
    entityId: number = 0;
    personType: number = -1;
    pixAddressKeyType: string = "";
    pixAddressKey: string = "";
  }
}
